import moment from "moment";

const MIN_DATE = new Date("01/01/2021");

const paidMonthColumn = () => ({
	name: "paidMonth",
	type: "month-year-picker" as const,
	placeholder: "Paid Month",
	formatLabel: value => {
		return moment(value).format("MMMM YYYY");
	},
	minDate: MIN_DATE,
	maxDate: new Date(),
});

export default paidMonthColumn;
